import React from 'react'
import * as UI from 'ui'
import { SpaceBetween } from 'ui'
import * as Displays from 'support/displays'
import { Translation, Translator } from '@morningtrain/react-translations'
import Widget from 'widgets/Widget'
import { ValueToCollection } from '@morningtrain/react-resources'
import SmartviewTextGroup from 'widgets/smartviews/partials/SmartviewTextGroup'
import SmartviewContentSeparator from 'widgets/smartviews/partials/SmartviewContentSeparator'
import SmartviewText from 'widgets/smartviews/partials/SmartviewText'
import WhenMultipleDepartmentsAreSelected from 'support/conditionals/WhenMultipleDepartmentsAreSelected'

export default function TotalGuestCountSummaryWidget ({ className }) {
  return (
    <Widget>
      <Translator namespace='economy.guest_count'>
        <UI.Card paddingBottom={false} className={className}>
          <SpaceBetween>
            <UI.Text weight='medium' size='lg'>
              <Translation name='title' />
            </UI.Text>
          </SpaceBetween>

          <ValueToCollection name='entries'>

            <div className='flex flex-col flex-grow flex-shrink pt-6'>

              <UI.Text weight='medium' size='3xl'>
                <Displays.Aggregate name='guestcount' display={<Displays.Integer />} />
                <UI.Text weight='medium' size='xs' color='gray' className='pl-2'>
                  <Translation name='visitors' />
                </UI.Text>
              </UI.Text>

              <SmartviewContentSeparator />

              <SmartviewTextGroup highlight highlightSize='card'>

                <SmartviewText>
                  <UI.SpaceBetween>
                    <UI.Text size='base'>
                      <WhenMultipleDepartmentsAreSelected>
                        <Translation name='generic.group' />
                      </WhenMultipleDepartmentsAreSelected>
                      <WhenMultipleDepartmentsAreSelected negate>
                        <Translation name='generic.guest_count' />
                      </WhenMultipleDepartmentsAreSelected>
                    </UI.Text>

                    <UI.Text weight='medium' size='base' align='right' color='black'>
                      <Displays.Aggregate name='guestcount' display={<Displays.Integer />} />
                    </UI.Text>

                  </UI.SpaceBetween>
                </SmartviewText>

                <SmartviewText>
                  <UI.SpaceBetween>
                    <UI.Text size='base'>
                      <WhenMultipleDepartmentsAreSelected>
                        <Translation name='generic.group' /> (LY)
                      </WhenMultipleDepartmentsAreSelected>
                      <WhenMultipleDepartmentsAreSelected negate>
                        <Translation name='generic.guest_count' /> (LY)
                      </WhenMultipleDepartmentsAreSelected>
                    </UI.Text>

                    <UI.Text weight='medium' size='base' align='right' color='black'>
                      <Displays.Aggregate name='guestcount_ly' display={<Displays.Integer />} />
                    </UI.Text>

                  </UI.SpaceBetween>
                </SmartviewText>

                <WhenMultipleDepartmentsAreSelected>
                  <SmartviewText>
                    <UI.SpaceBetween>
                      <UI.Text size='base'>
                        1:1
                      </UI.Text>

                      <UI.Text weight='medium' size='base' align='right' color='black'>
                        <Displays.Aggregate name='guestcount_production' display={<Displays.Integer />} />
                      </UI.Text>

                    </UI.SpaceBetween>
                  </SmartviewText>

                  <SmartviewText>
                    <UI.SpaceBetween>
                      <UI.Text size='base'>
                        1:1 (LY)
                      </UI.Text>

                      <UI.Text weight='medium' size='base' align='right' color='black'>
                        <Displays.Aggregate name='guestcount_production_ly' display={<Displays.Integer />} />
                      </UI.Text>

                    </UI.SpaceBetween>
                  </SmartviewText>
                </WhenMultipleDepartmentsAreSelected>

              </SmartviewTextGroup>

            </div>

            <div className='flex justify-center my-4 pt-6 text-center flow-row flex-nowrap'>
              <UI.WithSubtitle
                className='flex-grow'
                subtitle={(
                  <UI.Text weight='medium' color='black'>
                    <Displays.AggregateChange
                      name='guestcount_production'
                      outOfName='guestcount_production_ly'
                      display={(
                        <Displays.Percentage
                          showPlusIfPositive
                          decimals={1}
                          badBelow={0}
                        />
                        )}
                    />
                  </UI.Text>
                )}
              >
                <UI.Text uppercase size='xs' color='gray'>
                  <Translation name='generic.last_year' />
                </UI.Text>
              </UI.WithSubtitle>

              <WhenMultipleDepartmentsAreSelected>
                <UI.WithSubtitle
                  className='flex-grow'
                  subtitle={(
                    <UI.Text weight='medium' color='black'>
                      <Displays.AggregateChange
                        name='guestcount_production'
                        outOfName='guestcount_production_ly'
                        display={(
                          <Displays.Percentage
                            showPlusIfPositive
                            decimals={1}
                            badBelow={0}
                          />
                          )}
                      />
                    </UI.Text>
                    )}
                >
                  <UI.Text uppercase size='xs' color='gray'>
                    <Translation name='generic.last_year' />
                    <span> (1:1)</span>
                  </UI.Text>
                </UI.WithSubtitle>
              </WhenMultipleDepartmentsAreSelected>
            </div>

          </ValueToCollection>

        </UI.Card>
      </Translator>
    </Widget>
  )
}
